import React, { useReducer, useEffect } from 'react'
import adminApi from '../../api/admin.api'

const defaultState = {
  agencies: [],
  networks: [],
  commissions: {},
}

const ACTIONS = {
  LOAD_AGENCIES: 'LOAD_AGENCIES',
  LOAD_NETWORKS: 'LOAD_NETWORKS',
  LOAD_COMMISSIONS: 'LOAD_COMMISSIONS',
}

const reducer = (state, action) => {
  console.log('AdminContext state', state, action)
  switch (action.type) {
    case ACTIONS.LOAD_AGENCIES:
      return { ...state, agencies: action.data }
    case ACTIONS.LOAD_NETWORKS:
      return { ...state, networks: action.data }
    case ACTIONS.LOAD_COMMISSIONS:
      return { ...state, commissions: action.data }
    default:
      return state
  }
}

export const AdminContextStore = React.createContext(defaultState)

const AdminContext = props => {
  const [state, dispatch] = useReducer(reducer, defaultState)

  const loadAgencies = async () => {
    let res = await adminApi.loadAgencies()
    if (res.ok) {
      dispatch({ type: ACTIONS.LOAD_AGENCIES, data: res.data.agencies })
    }
  }

  const loadNetworks = async () => {
    let res = await adminApi.loadNetworks()
    if (res.ok) {
      dispatch({ type: ACTIONS.LOAD_NETWORKS, data: res.data.networks })
    }
  }
  const loadCommissions = async () => {
    let res = await adminApi.loadCommissions()
    if (res.ok) {
      dispatch({ type: ACTIONS.LOAD_COMMISSIONS, data: res.data })
    }
  }

  useEffect(() => {
    loadAgencies()
    loadNetworks()
    loadCommissions()
    return function cleanup() {}
  }, [])

  return <AdminContextStore.Provider value={{ ...state, dispatch, loadAgencies }}>{props.children}</AdminContextStore.Provider>
}

export default AdminContext
